import React from 'react';
import PropTypes from "prop-types";

const MonthElement = ({ selectedMonth, isStartMonth, isEndMonth, isInRange, month} ) => {
  let selClassName = (!selectedMonth && !isStartMonth && !isEndMonth && !isInRange) ? 'month-picker__month-label': `
    month-picker__month
    ${(selectedMonth)?' month-picker__month_selected': ''}
    ${(isStartMonth)?' month-picker__month_selected-left': ''}
    ${(isEndMonth)? ' month-picker__month_selected-right': ''}
  `;

  return (
    <span className={ `month-btn ${selClassName}` }>{month[0]}</span>
  );
};

MonthElement.propTypes = {
  month: PropTypes.string.isRequired,
  isInRange: PropTypes.bool,
  isEndMonth: PropTypes.bool,
  isStartMonth: PropTypes.bool,
  selectedMonth: PropTypes.bool
};

export default MonthElement;




// WEBPACK FOOTER //
// ./src/shared/components/monthPicker/comp/monthElement/MonthElement.js